import { render } from "./ChevronsLeft.vue?vue&type=template&id=4f47e76e&scoped=true"
const script = {}

import "./ChevronsLeft.vue?vue&type=style&index=0&id=4f47e76e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f47e76e"]])

export default __exports__